export enum ExportScreen {
  FilterTab = 'FILTER_TAB',
  TaxAccounting = 'TAX_ACCOUNTING',
}

export enum YearFilterType {
  AllIssue = 'ALL_ISSUE',
  AmendedReturn = 'AMENDED_RETURN',
  Saa = 'SAA',
  CcnLegal = 'CCN_LEGAL',
}

export enum TaxAccountingIssueType {
  AllIssues = 'All Issues',
  Asc74010 = 'ASC 740-10',
}

export enum FilterTabActiveFilter {
  IssueId = 'ISSUE_ID',
  FromDate = 'FROM_DATE',
  IssueStatus = 'ISSUE_STATUS',
  ArFilingId = 'AR_FILING_ID',
  ArIssueId = 'AR_ISSUE_ID',
  Year = 'YEAR',
}

export enum TaxAccountingActiveFilter {
  IssueId = 'ISSUE_ID',
  Tbbs = 'TBBS',
  IssueStatus = 'ISSUE_STATUS',
  IssueDate = 'ISSUE_DATE',
}
